import React from 'react'
import { Card, Typography, Empty } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

const ActivityActionsContent = ({ accountData }) => {
  return (
    <div>
      <Card
        size='small'
        title={
          <Title level={5} style={{ margin: 0 }}>
            Activity & Actions
          </Title>
        }
      >
        <Empty
          image={<ClockCircleOutlined style={{ fontSize: 48, color: '#d9d9d9' }} />}
          description={
            <div>
              <Text type='secondary' style={{ fontSize: 16 }}>
                Coming Soon
              </Text>
              <br />
              <Text type='secondary'>
                Activity tracking, call logging, and communication actions will be available in the next release.
              </Text>
            </div>
          }
        />
      </Card>
    </div>
  )
}

export default ActivityActionsContent
